/* Leaft Blade V2 — geo notice. Detects the visitor's country and, if it differs
   from this storefront's home country, shows either a waitlist message (markets
   we can't ship to) or a reroute link (the US store). Dismissible + remembered.

   Country detection: Shopify's /browsing_context_suggestions or the CDN country
   cookie is not guaranteed on all plans, so we use a lightweight geo endpoint
   with a timeout and fail silent — the notice simply never shows on error. */
(() => {
  const root = document.querySelector('[data-lb2-geo]');
  if (!root) return;

  const DISMISS_KEY = 'lb2-geo-dismissed';
  if (localStorage.getItem(DISMISS_KEY) === '1') return;

  const configEl = document.querySelector('[data-lb2-geo-config]');
  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  const home = (root.dataset.homeCountry || 'NZ').toUpperCase();
  const usUrl = root.dataset.usUrl;
  const msgEl = root.querySelector('[data-lb2-geo-msg]');
  const ctaEl = root.querySelector('[data-lb2-geo-cta]');
  const closeEl = root.querySelector('[data-lb2-geo-close]');

  closeEl.addEventListener('click', () => {
    root.classList.remove('is-visible');
    localStorage.setItem(DISMISS_KEY, '1');
  });

  function show(country) {
    if (!country || country === home) return;

    const unship = config.unshippable && config.unshippable[country];
    const reroute = config.reroute && config.reroute[country];

    if (unship) {
      msgEl.innerHTML = unship.message;
      ctaEl.textContent = unship.cta;
      ctaEl.href = unship.url || '#';
    } else if (reroute && usUrl) {
      msgEl.innerHTML = reroute.message;
      ctaEl.textContent = reroute.cta;
      ctaEl.href = usUrl;
    } else {
      return;
    }
    root.classList.add('is-visible');
  }

  function detect() {
    // Prefer the Shopify country cookie if present.
    const m = document.cookie.match(/(?:^|;\s*)cart_currency=([A-Z]{3})/);
    // Fall back to a geo lookup with a short timeout.
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), 2500);
    fetch('https://ipapi.co/json/', { signal: controller.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        clearTimeout(t);
        if (data && data.country_code) show(data.country_code.toUpperCase());
      })
      .catch(() => {});
  }

  detect();
})();
